import * as breakpoints from "../../breakpoints";
import * as colors from "../../constants/colors";
import { Container, Column, Row } from "../../grid";
import { english, spanish } from "../../constants/strings";
import { css, StyleSheet } from "aphrodite";
import { me } from "../../api/account";
import { completeClassUrl, getClass, startClass } from "../../api/class";
import { handleUnknownError } from "../../lib/errorHandler";
import browserHistory from "react-router/lib/browserHistory";
import Page from "../Page";
import { NotificationManager } from "react-notifications";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import * as languages from "../../constants/languages";
import { anonymousEmail } from "../../config";

const styles = StyleSheet.create({
	pageContainer: {
		minHeight: "100vh",
		position: "relative",
	},
	contentContainer: {
		backgroundColor: colors.white,
		paddingTop: 45,
		flexDirection: "column",
		display: "flex",
		[breakpoints.mobileOnly]: {
			paddingLeft: 20,
			paddingRight: 20,
			marginTop: 60,
			paddingBottom: 20,
			marginBottom: 240,
		},
	},
	title: {
		textAlign: "center",
		fontSize: 55,
		lineHeight: 0.82,
		fontWeight: "normal",
		color: colors.black,
		fontFamily: "priori-sans",
	},
	button: {
		display: "inline-block",
		borderRadius: 20,
		backgroundColor: colors.white,
		color: colors.purple5,
		fontWeight: "bold",
		lineHeight: 2,
		fontSize: 15,
		fontFamily: "freight-sans-pro",
		textDecoration: "none",
		paddingTop: 5,
		paddingBottom: 5,
		width: 170,
		border: `3px solid ${colors.purple5}`,
		[breakpoints.mobileOnly]: {
			width: 85,
		},
	},
	buttonContainer: {
		textAlign: "center",
		marginTop: 32,
	},
	questionContainer: {
		fontFamily: "freight-sans-pro",
		fontSize: 18,
		linHeight: 1.39,
		color: colors.black7,
	},
	form: {
		paddingTop: 28,
		paddingBottom: 32,
		paddingLeft: 38,
		paddingRight: 38,
		fontFamily: "priori-sans",
		backgroundColor: colors.purple3,
		marginTop: 12,
		[breakpoints.mobileOnly]: {
			paddingTop: 20,
			paddingLeft: 20,
			paddingRight: 20,
			paddingBottom: 26,
		},
	},
	formItem: {
		marginTop: 22,
		display: "flex",
		flexDirection: "column",
	},
	input: {
		fontSize: 15,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
	},
});

export default class CertificateQuestionPage extends PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		params: PropTypes.object.isRequired,
		loggedIn: PropTypes.bool.isRequired,
		sessionId: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = {
			error: null,
			email: anonymousEmail,
			pageTitle: "",
			certificateQuestion: "",
		};
	}

	componentDidMount() {
		this._loadClass(this.props.params.class_id);
		this._getMe();
	}

	_getMe = () => {
		me()
			.then(data => {
				this.setState({
					email: data.email,
				});
				// start live class if logged in
				startClass(this.props.params.class_id, this.props.language, this.props.sessionId);
			})
			.catch(() => {
				console.log("failed to get user data");
			});
	};

	_loadClass = classId => {
		getClass(classId, this.props.language === languages.es ? languages.es : null)
			.then(data => {
				this.setState({
					pageTitle: data.name,
					certificateQuestion: data.readerQuestion,
				});
			})
			.catch(err => {
				handleUnknownError(err);
				NotificationManager.error(this.strings.errors.failedToLoadClass);
				if (err.response && err.response.status === 404) {
					browserHistory.push({
						pathname: "/catalog",
						query: { language: this.props.language },
					});
				}
			});
	};

	_setAnswer = e => {
		const ans = e.target.value;
		this.setState({
			answer: ans,
		});
	};

	render() {
		return (
			<Page
				activeTab={this.strings.tabNames.MY_CLASSES}
				currentRoute={this.props.pathname}
				language={this.props.language}
				loggedIn={this.props.loggedIn}
			>
				<Container>
					<Row>
						<Column
							large={8}
							largeOffset={2}
							medium={10}
							mediumOffset={1}
							smallFullScreen={true}
						>
							<div id="main" className={css(styles.contentContainer)}>
								<h1 className={css(styles.title)}>{this.state.pageTitle}</h1>
								<div className={css(styles.questionContainer)}>
									{this.state.certificateQuestion}
								</div>
								<form className={css(styles.form)}>
									<div className={css(styles.formItem)}>
										<textarea
											className={css(styles.input)}
											rows={4}
											id="answer"
											type="text"
											value={this.state.answer}
											onChange={this._setAnswer}
										/>
									</div>
									<div className={css(styles.errorMessage)}>
										{this.state.error}
									</div>
									<div className={css(styles.buttonContainer)}>
										<a
											className={css(styles.button)}
											href={completeClassUrl(
												this.props.params.class_id,
												this.state.email,
												this.state.answer,
												this.props.language,
												this.props.sessionId,
											)}
										>
											{this.strings.SUBMIT}
										</a>
									</div>
								</form>
							</div>
						</Column>
					</Row>
				</Container>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/CertificateQuestionPage.js